import { render, staticRenderFns } from "./SendSign.vue?vue&type=template&id=10f884e4&scoped=true&"
import script from "./SendSign.vue?vue&type=script&lang=js&"
export * from "./SendSign.vue?vue&type=script&lang=js&"
import style0 from "./SendSign.vue?vue&type=style&index=0&id=10f884e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f884e4",
  null
  
)

export default component.exports